import React from 'react';
import styles from './styles.module.css';

export type PilotLoaderVariant = 'fullscreen' | 'contained';

export type PilotLoaderProps = {
  message: string;
  subtitle?: string;
  hiding?: boolean;
  /* `fullscreen` (default) pins the overlay to the viewport via `position: fixed` and is the
   * shape used by global orchestration sites (modal submits via withLoaderIfSlow).
   * `contained` switches to `position: absolute` so the overlay fills its nearest positioned
   * ancestor — used to scope the loader to a region of the page (e.g. only the right panes
   * of the conversations layout instead of the whole viewport). */
  variant?: PilotLoaderVariant;
};

export function PilotLoader({
  message,
  subtitle,
  hiding,
  variant = 'fullscreen',
}: PilotLoaderProps): React.ReactNode {
  const overlayClassName = [
    styles.overlay,
    variant === 'contained' ? styles.overlayContained : null,
    hiding ? styles.hiding : null,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={overlayClassName} role="status" aria-live="polite">
      <div className={styles.stage}>
        <div className={styles.glow} />
        <div className={styles.ring} />
        <div className={`${styles.ring} ${styles.ringDelay}`} />
        <div className={styles.orb} />
        <div className={`${styles.orbit} ${styles.orbit1}`} />
        <div className={`${styles.orbit} ${styles.orbit2}`} />
        <div className={`${styles.orbit} ${styles.orbit3}`} />
      </div>
      <div>
        <div className={styles.message}>{message}</div>
        {subtitle ? <div className={styles.subtitle}>{subtitle}</div> : null}
      </div>
    </div>
  );
}
